
export const ronMediaArray = [
  {
    _id: 'ronMediaId1',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `Go on a date with me or else`,
      `The intense look is because the only spell I know is Lumos`,
      `Stop right there and give me all your chocolate frogs!`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId2',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `The lenses were circular but then I saw you`,
      `What's not to love`,
      `Let's pretend I'm romantic`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId3',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend I'm thinking something profound`,
      `Tell me my hair looks pretty or else`,
      `Did I leave the toilet seat up?`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId4',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `I'm known for`,
      `My quarter life crisis looks like`
    ],
    subcaptions: [
      `Emergency: Forgot all my charms`,
      `Overthinking everything, per usual`,
      `The skeleton of an eligible suitor`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId5',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Focusing hard on my Patronus but the only thing that's happening is Lumos`,
      `Trying very hard to look serious`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId6',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Certified first class male`,
      `Passions include muggle collectibles such as stamps`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId7',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-7-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `All black, an attempt to look classy or the dark magic of the heart?`,
      `My "I just rode a dragon" face`,
      `Extremely concerned that I may have answered a question incorrectly on my OWL.`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId8',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-8-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Tell me my hair looks good or else`,
      `Warning: will sneak around and hide behind pillars`,
      `Wearing green to disguise myself as Slytherin`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId9',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-9-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Let's assume the guns are impressive`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `The world is your dragonwalk`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId10',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-10-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Focusing hard on my Patronus but the only thing that's happening is Lumos`,
      `Trying very hard to look serious`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId11',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-11-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `My vulnerable side`,
      `Life outtake`
    ],
    subcaptions: [
      `I didn't see it, my hair was in my eyes`,
      `Fine, I'll tighten my tie`,
      `Fine, I'll tuck in my shirt`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId12',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-12-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Trying very hard to look serious`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `The world is your dragonwalk`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId13',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-13-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `My weekends look like`,
      `As seen on my Mom's fridge`
    ],
    subcaptions: [
      `Rare footage of me in a blazer`,
      `Wearing green to disguise myself as Slytherin`,
      `When you know 50 points are about to be taken from Gryffindor`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId14',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-14-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `I didn't see it, my hair was in the way`,
      `Loosen another button, sure`,
      `My "I just stole your chocolate frog" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'ronMediaId15',
    userId: 'ronUserId',
    email: 'ron@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-15-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-15-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Leave a one-word review for this`,
      `Me in the wild`
    ],
    subcaptions: [
      `I promise to love and care for you like a pet rat`,
      `I swear I'm not about to cry`,
      `My "I just saw a troll" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]